import { Action } from 'redux';
import {
  SalesTax,
  User,
  currentOrder,
  currentOrderInfo,
} from 'src/types/model';

export interface currentOrderState {
  order: currentOrder;
  taxes: SalesTax[];
  deliveryCharge: number;
  users: User[];
  currentUser: {
    id: string;
    name: string;
    email: string;
    phone: number;
  } | null;
}

export const CLEAR_CURRENT_ORDER = 'CLEAR_CURRENT_ORDER';
export const ADD_CURRENT_ORDER = 'ADD_CURRENT_ORDER';
export const ADD_CURRENT_ORDER_INFO = 'ADD_CURRENT_ORDER_INFO';
export const FETCH_TAXES_ORDER = 'FETCH_TAXES_ORDER';
export const FETCH_USERS_ORDER = 'FETCH_USERS_ORDER';
export const ADD_CURRENT_USER = 'ADD_CURRENT_USER';
export const FETCH_DELIVERY_CHARGE_ORDER = 'FETCH_DELIVERY_CHARGE_ORDER';
export const INCREASE_QUANTITY_CURRENT_ORDER =
  'INCREASE_QUANTITY_CURRENT_ORDER';
export const DECREASE_QUANTITY_CURRENT_ORDER =
  'DECREASE_QUANTITY_CURRENT_ORDER';

export interface ClearCurrentOrderAction
  extends Action<typeof CLEAR_CURRENT_ORDER> {}

export interface AddCurrentUserAction extends Action<typeof ADD_CURRENT_USER> {
  payload: {
    id: string;
    name: string;
    email: string | null;
    phone: number | null;
    image: string | null;
  } | null;
}

export interface AddCurrentOrderAction
  extends Action<typeof ADD_CURRENT_ORDER> {
  payload: currentOrder;
}
export interface AddCurrentOrderInfoAction
  extends Action<typeof ADD_CURRENT_ORDER_INFO> {
  payload: currentOrderInfo;
}

export interface FetchTaxesOrderAction
  extends Action<typeof FETCH_TAXES_ORDER> {
  payload: SalesTax[];
}

export interface FetchDeliveryChargeOrderAction
  extends Action<typeof FETCH_DELIVERY_CHARGE_ORDER> {
  payload: number;
}

export interface FetchUsersOrderAction
  extends Action<typeof FETCH_USERS_ORDER> {
  payload: User[];
}

export interface IncreaseQuantityOrderAction
  extends Action<typeof INCREASE_QUANTITY_CURRENT_ORDER> {
  payload: { id: string; quantity: number };
}

export interface DecreaseQuantityOrderAction
  extends Action<typeof DECREASE_QUANTITY_CURRENT_ORDER> {
  payload: { id: string; quantity: number };
}

export type CurrentOrderActionType =
  | ClearCurrentOrderAction
  | AddCurrentOrderAction
  | FetchTaxesOrderAction
  | IncreaseQuantityOrderAction
  | DecreaseQuantityOrderAction
  | FetchUsersOrderAction
  | AddCurrentUserAction
  | AddCurrentOrderInfoAction
  | FetchDeliveryChargeOrderAction;
